import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import clientApi from "../../api/client";
import { selectClientRightUserList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getClientRightUserList(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientRightUserList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.clientRightUserListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const rightUserList = await clientApi.getClientRightUserList(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, rightUserList);

      dispatch(
        actions.clientRightUserListFetchSuccess({
          data: rightUserList.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.clientRightUserListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getClientRightUserListCount(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientRightUserList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.clientRightUserListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await clientApi.getClientRightUserCount(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();

      dispatch(actions.clientRightUserListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.clientRightUserListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeClientRightUserListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientRightUserListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeClientRightUserListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientRightUserListChangePage(page));
  };
}

export function changeClientRightUserListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientRightUserListChangeFilter(filter));
  };
}

export function clientRightUserListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectClientRightUserList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.clientRightUserListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.clientRightUserListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
